export default __webpack_public_path__ + "locales/ko-KR/Settings.json?hash=7312401c824cc012dc0ce3fc8bcfd547";